<script setup lang="ts">
import { computed } from 'vue'
import { stateLabel, stateTone } from '../core/ui'
const props = withDefaults(
  defineProps<{
    state?: string
    label?: string
    tone?:
      | 'neutral'
      | 'positive'
      | 'warning'
      | 'danger'
      | 'info'
      | 'good'
      | 'warn'
  }>(),
  { state: '', label: '', tone: 'neutral' },
)
const resolvedLabel = computed(
  () => props.label || (props.state ? stateLabel(props.state) : ''),
)
const resolvedTone = computed(() => {
  const raw =
    props.tone !== 'neutral'
      ? props.tone
      : props.state
        ? stateTone(props.state)
        : 'neutral'
  if (raw === 'good') return 'positive'
  if (raw === 'warn') return 'warning'
  return raw
})
</script>
<template>
  <span class="status-badge" :data-tone="resolvedTone"
    ><slot>{{ resolvedLabel }}</slot></span
  >
</template>
